module.exports = __webpack_public_path__ + "static/img/pt.b908edae.svg";